// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1hKi_","options":"AnswerScale_options__3n36x","selected":"AnswerScale_selected__3__05"};